import { useApolloClient, useMutation } from "@apollo/client";
import { notifications } from "@mantine/notifications";
import { REQUEST_WITHDRAWEL } from "../../../apis/lambda/GraphQL/Stripe/mutations";
import { GET_USER_BALANCE } from "../../../apis/lambda/GraphQL/Stripe/queries";
import { GET_USER } from "../../../apis/lambda/GraphQL/User/queries";

export const useTransferBalance = () => {
  const client = useApolloClient();

  const [requestWithdrawal, { loading, error }] =
    useMutation(REQUEST_WITHDRAWEL);

  const transfer = async () => {
    try {
      await requestWithdrawal();
      // Refetch both user data and balance after withdrawal
      client.refetchQueries({ include: [GET_USER, GET_USER_BALANCE] });
      // Update the balance cache timestamp to force a fresh fetch
      localStorage.setItem("balance_last_fetched", Date.now().toString());
      notifications.show({
        title: "Transfer Initiated",
        message: "Your balance is on its way to your bank account!",
        color: "green",
      });
    } catch (e) {
      console.error("Error requesting withdrawal:", e);
      notifications.show({
        title: "Error",
        message: "Failed to initiate transfer. Please try again.",
        color: "red",
      });
    }
  };

  return { transfer, loading, error };
};
